import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const LoaderBanner = styled(FlexContainer)`
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_success};
  height: 15%;
  border-radius: ${({ theme: { system } }) =>
    `${system.fds_sys_borderradius_L} ${system.fds_sys_borderradius_L} 0 0`};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    padding: ${({ theme: { reference } }) => reference.dimension_24};
  }
`;

export const LoaderContainer = styled(FlexContainer)`
  width: 480px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
`;
